
export class TeamGeneralInfoItem {
  public name: string;
  public noc: string;


  constructor(rawTeamGeneralInfoItem: any) {
    this.name = rawTeamGeneralInfoItem.Name;
    this.noc = rawTeamGeneralInfoItem.NOC;
  }
}